import * as React from 'react';
import { Create, CreateProps, SimpleForm, TextInput } from 'react-admin';
import { UploadImage } from '../components/UploadImage';

export const ProductCategoryCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="name" label="NAME"/>
				{/*<TextInput multiline step={1} source="description" label="DESCRIPTION"/>*/}
				<UploadImage step={1} source="imageUrl" label="IMAGE"/>
			</SimpleForm>
		</Create>
	);
};
